module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-taiguo.c34cde7d.webm";